// The font, size and spacing choices the two text editors offer.
//
// Shared so the modal editor and the on-slide ribbon cannot drift apart — a
// size available in one and missing from the other is the kind of difference
// an author reads as a bug.
//
// Deliberately its own module rather than an export from RichTextEditor.js:
// that file imports TipTap, which is the largest thing in the bundle and is
// deliberately kept out of the startup graph (see
// components/__tests__/lazyEditors.test.js). SlideDesigner is *not* lazily
// loaded, so importing the constants from the editor would drag the whole
// editor stack back into the initial bundle. This module imports nothing.

/**
 * Sizes are in points because that is what the rest of the lesson world —
 * Word, PowerPoint, the export pipeline — measures type in, and an author
 * copying a spec sheet should not have to convert.
 */
export const FONT_FAMILIES = [
  { label: 'Default', value: '' },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Calibri', value: 'Calibri, Candara, Segoe, sans-serif' },
  { label: 'Georgia', value: 'Georgia, "Times New Roman", serif' },
  { label: 'Helvetica', value: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  { label: 'Segoe UI', value: '"Segoe UI", Tahoma, sans-serif' },
  { label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Courier New', value: '"Courier New", Courier, monospace' }
];

export const FONT_SIZES = [
  '', '10pt', '11pt', '12pt', '14pt', '16pt', '18pt',
  '20pt', '24pt', '28pt', '32pt', '40pt', '48pt'
];

export const LINE_HEIGHTS = [
  { label: 'Spacing', value: '' },
  { label: 'Single', value: '1' },
  { label: '1.15', value: '1.15' },
  { label: '1.5', value: '1.5' },
  { label: 'Double', value: '2' },
  { label: '2.5', value: '2.5' },
  { label: 'Triple', value: '3' }
];
